import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAssetWorkspacePath } from "@/features/tickets/lib/get-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getAssetWorkspacePath({
				orgId: params.orgId,
				ticketId: params.ticketId,
				assetId: params.assetId,
				tab: "form",
			}),
		});
	},
});
